export function translationReasoningRenderer(params: { value?: string }) {
  if (!params.value) {
    return '<span style="color: #999;">N/A</span>';
  }

  function escapeHtml(text: string): string {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  }


  // Escape HTML to display tags like <glossary> as plain text
  const escapedText = escapeHtml(params.value);

  return `
    <div style="
      padding: 6px 0;
      line-height: 1.5;
      word-break: break-word;
    ">
      ${escapedText}
    </div>
  `;
}